$(document).ready(function() {

	singleProductOwl();
//   ghostProductPullPush();
//   reTriggerZoom();
//   triggerZoom();

});
$(window).on('resize', function(e) {
	singleProductOwl();
});
function singleProductOwl() {
	$('#owl-product-single').owlCarousel({
		items: 1,
		loop: true,
		margin: 0,
		nav: false,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: true,
      autoHeight:true,
// 		autoplay: false,
// 		autoplayHoverPause: true,
		navText: [
			// "<img src='assets/images/arrow-left.png'>",
			// "<img src='assets/images/arrow-right.png'>",
			"<img src='https://cdn.shopify.com/s/files/1/0081/8154/7061/files/arrow-left.png?721'>",
			"<img src='https://cdn.shopify.com/s/files/1/0081/8154/7061/files/arrow-right.png?721'>"
		],
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 1
			},
			1000: {
				items: 1
			}
		}
	});
}
function productsOwlRelated() {
	$('#related-products').owlCarousel({
		items: 4,
		loop: true,
		margin: 30,
		nav: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		autoplay: false,
		autoplayHoverPause: true,
		navText: [
			// "<img src='assets/images/arrow-left.png'>",
			// "<img src='assets/images/arrow-right.png'>",
			"<img src='https://cdn.shopify.com/s/files/1/0081/8154/7061/files/arrow-left.png?721'>",
			"<img src='https://cdn.shopify.com/s/files/1/0081/8154/7061/files/arrow-right.png?721'>"
		],
		responsive: {
			320: {
				items: 1,
				margin: 0
			},
			600: {
				items: 3,
				margin: 10
			},
			1000: {
				items: 4
			}
		}
	});
}


$(document).ready(function() {

  var stickyNav = function(){
    var scrollTop = $(window).scrollTop();

    if (scrollTop > 51) { 
      $(".top").slideUp(600);
      $('.sticky').addClass('fixed transition');

    }
    if(scrollTop < 51){
      $('.sticky').removeClass('fixed').addClass('transition');
      $(".top").slideDown(600); 
    }
  }; 
  stickyNav();

  $(window).scroll(function() {
    stickyNav();
  });
});
